import { LINK_ID_REG } from '@aytm/app/stats/page/question-views/components/lib/constants'

// the measures a max-diff is read in, in the order the deck lays them out
export const VIEW_MODES = ['varyingProbability', 'probability', 'raw']

export const getViewModeList = (itemsPerSet = 4) => [
  {
    text: `Preference Likelihood (${itemsPerSet}/screen)`,
    value: 'varyingProbability',
    listText: `Preference Likelihood (${itemsPerSet}/screen)`
  },
  {
    text: 'Average-based PL (50% baseline)',
    value: 'probability',
    listText: 'Average-based PL (50% baseline)'
  },
  {
    text: 'Utility Scores',
    value: 'raw',
    listText: 'Utility Scores'
  }
]

export const getCurrentConfig = answer => answer?.config || window?.survey?.config?.md || { v: 2 }

export const getDefaultViewMode = (format, answer) => {
  if (format?.viewMode) {
    return format.viewMode
  }
  return 1 === getCurrentConfig(answer)?.v ? 'probability' : 'varyingProbability'
}

export const linkIsCorrectFormat = link => link?.length > 0 && LINK_ID_REG.test(link)

export const isShowExport = ({ featureAuthorizedExportsIsEnabled, maxDiffType, isReportXpert, link }) => {
  const featureIsEnabled = featureAuthorizedExportsIsEnabled && maxDiffType >= 1
  const hasExportAccess = !isReportXpert || linkIsCorrectFormat(link)

  return featureIsEnabled && hasExportAccess
}

export const isShowHead = ({ maxDiffType, answer }) => {
  // bad-data read mirrors the block gate: array form uses [0], boolean form is taken as-is
  const badData = Array.isArray(answer?.badData) ? true === answer.badData[0] : true === answer?.badData
  const difference = answer?.difference ?? 0
  // absent actualData means "data is actual" — only an explicit false suppresses the banner (matches the data-run gate)
  const actualData = answer?.actualData !== false

  return 1 <= maxDiffType && actualData && !badData && !difference
}

export const getDataExportOptions = ({ itemsPerSet, specialExport, featureTurfIsEnabled }) => {
  const specialExportConfigTurf = specialExport?.config?.turf || {}

  const isAvaliableTurfExport = specialExportConfigTurf.default && featureTurfIsEnabled
  const turfOptionsConfig = specialExportConfigTurf.available?.[specialExportConfigTurf.default]

  // `key` identifies the row in the export dropdown and must be unique -- the file
  // type lives in its own field. Sharing one `key: 'csv'` across rows made the
  // dropdown's selected value ambiguous, losing the exportMethod distinction.
  return [
    {
      text: `Download Preference Likelihood (${itemsPerSet}/screen)`,
      exportMethod: 'varyingProbability',
      key: 'maxdiff-varyingProbability',
      fileType: 'csv',
      exportType: 'maxdiff'
    },
    {
      text: 'Download Average-based PL (50% baseline)',
      exportMethod: 'probability',
      key: 'maxdiff-probability',
      fileType: 'csv',
      exportType: 'maxdiff'
    },
    {
      text: 'Download Utility Scores (CSV)',
      exportMethod: 'raw',
      key: 'maxdiff-raw',
      fileType: 'csv',
      exportType: 'maxdiff'
    },
    ...(isAvaliableTurfExport
      ? [
          {
            key: 'turf',
            fileType: turfOptionsConfig?.fileType,
            exportType: 'turf',
            exportMethod: specialExportConfigTurf?.default,
            exportMethodText: turfOptionsConfig?.xlsxText,
            text: 'Download TURF (default method)'
          }
        ]
      : []),
    {
      key: 'stacked',
      fileType: 'csv',
      exportType: 'stacked',
      exportMethod: 'maxdiff',
      text: 'Stacked choice data (CSV)'
    }
  ]
}
